import { getHighestRole, ROLE_USER, type TRole } from '#interfaces/auth'

import type { TLook } from './interfaces'

export const LOOK_STORAGE_KEY = 'wijmobiel-look'

/** Travellers get the app look; every other role the classic look. */
export function lookForRoles(roles: TRole[]): TLook {
  return getHighestRole(roles) === ROLE_USER ? 'app' : 'classic'
}

/** The look stored by the last session: a cosmetic hint for the first paint, never for authorisation. */
export function readStoredLook(): TLook {
  try {
    return localStorage.getItem(LOOK_STORAGE_KEY) === 'app' ? 'app' : 'classic'
  } catch {
    return 'classic'
  }
}

export function storeLook(look: TLook): void {
  try {
    localStorage.setItem(LOOK_STORAGE_KEY, look)
  } catch {
    // localStorage can be unavailable (privacy mode, disabled storage)
  }
}
